"use client"

import { datadog } from "@/platform/observability/datadog/facade"

import { trackEvent } from "./track"

import type { ExperimentInclusionEvent } from "./types/custom"

export function trackExperimentInclusion(params: ExperimentInclusionEvent["params"]): void {
  datadog.addFeatureFlagEvaluation(params.feature_name, params.treatment_name)
  datadog.setUserProperty(`experiment.${params.feature_name}`, params.treatment_name)

  trackEvent("xp_inclusion", params)
}
